module.exports = __webpack_public_path__ + "static/media/thomson-reuters.cf54a46c.svg";